/**
 * created by lei lei
 * 媒体账号管理列表
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Scrollbars} from "react-custom-scrollbars";
import Title from "../../../components/title/Title";
import {
    Select,
    Input,
        Button,
    Empty,
    Pagination,
    Modal,
    Row,
    Col,
    Checkbox,
    Tabs,
    DatePicker,
    Icon,
    Popconfirm, Upload, message
} from "antd";
import './MediaList.css'
import MediaInformation from "../../components/mediaInformation/MediaInformation";
import OrdinaryTrees from "../../../components/editor/OrdinaryTrees";
import moment from "moment";
import CustomTable, {TitleIcon} from "../../../components/customTable/CustomTable";
import keepRecordIcon from './img/keepRecordIcon.png'
import file from './img/file.png'
import exclamatioMark from './img/exclamatioMark.png'
import PageScrollBars from "../../../components/pageScrollBars/PageScrollBars";
import * as Action from '../../actions/horizontalManagement'
import WeChatReview from "../../../components/weChatReview/WeChatReview";
import MicroBlogReview from "../../../components/microBlogReview/MicroBlogReview";
import TiktokReview from "../../../components/tiktokReview/TiktokReview";
import SpacerBlock from "../../../components/spacerBlock/SpacerBlock";
import weChat from "./img/weChat.png";
import microBlog from "./img/microBlog.png";
import tiktok from "./img/tiktok.png";
import * as utils from '../../../../utils';
import {applicationName} from "../../../../utils";
import $ from "jquery";
const {Option} = Select;
const {TabPane} = Tabs;
const {MonthPicker, RangePicker} = DatePicker;
const {Search} = Input;
const dateFormat = 'YYYY-MM-DD';
const { TextArea } = Input;
export default class MediaManagementList extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.Actions = Action;
        this.state = {
            mediaTypes: null,//媒体类型
            mediaRecords: null,//备案状态
            id: null,//部门
            active: 1,//活跃度
            searchText: '',//搜索文字
            visible: false,
            recordMeida: [],//媒体信息备案状态
            directorStatus: false,
            mobileStatus: false,
            descriptionStatus: false,
            updateTimeStatus: false,
            fileModalVisible: false,

            visibleHistory: false,
            historyTitle: '',
            //媒体类型具体的个数
            weiChatCount: 0,//微信
            weiBoCount: 0,//微博个数
            douYinCount: 0,//抖音个数
            //获取媒体列表
            page: 1,//当前页
            size: 10,//每页条数
            listDataSource: [],//列表数据源
            listTotal: 0,//共有多少条
            //历史发文
            historyRecord: {},
            departAllList: [],//所有的部门
            lookImgUrl:'',
            mediaCurrentClickItem:{}

        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getMediaCount();
        this.getMediaList();
        this.getDeptAll();


    }

    //获取所有部门
    getDeptAll() {
        this.Actions.getDeptAll((data) => {
            let Data = data.data;
            if (Data) {
                let newData = Data;
                let depatList = newData;
                if (newData && depatList.length > 0) {
                    this.setState({
                        departAllList: depatList
                    })
                }
            }
        })
    }

    //获取媒体数
    getMediaCount() {
        let body={};
        this.Actions.getMediaCount(body,(data) => {
            if (data.data) {
                let Data = JSON.parse(data.data);
                Data.medias.forEach(item => {
                    if (item.type === 2) {
                        this.state.weiChatCount = item.total;
                    }
                    if (item.type === 3) {
                        this.state.weiBoCount = item.total;
                    }
                    if (item.type === 5) {
                        this.state.douYinCount = item.total;
                    }
                })
                this.setState({})
            }
        })
    }

    //获取媒体列表
    getMediaList() {
        let activeDate = null;
        if (this.state.active === 1) {
            activeDate = null;
        } else if (this.state.active === 2) {
            activeDate = moment().add(-7, 'days').format(' YYYY-MM-DD') + ' 00:00:00'
        } else if (this.state.active === 3) {
            activeDate = moment().add(-30, 'days').format(' YYYY-MM-DD') + ' 00:00:00'

        } else if (this.state.active === 4) {
            activeDate = moment().add(-120, 'days').format(' YYYY-MM-DD') + ' 00:00:00'

        }
        let body = {
            page: this.state.page - 1,
            size: this.state.size,
            mediaTypes: this.state.mediaTypes,
            mediaRecords: this.state.mediaRecords,
            activeDate: activeDate,
            search: this.state.searchText,
            deptId: this.state.id,
        };
        this.Actions.getMediaList(body, (data) => {
            let Data = data.data;
            if (Data && Data.content) {
                this.setState({
                    listDataSource: Data.content,
                    listTotal: Data.totalElements
                })
            }
        })
    }

    render() {
        return (
            <PageScrollBars content={
                <div className={'MediaManagementList'} style={{background: 'white'}}>
                    <Title
                        title={'新媒体列表'}
                    />
                    {this.renderScreen()}
                    <SpacerBlock/>
                    {this.renderList()}
                    {this.renderModal()}
                    {this.renderHistoryList()}
                    {this.renderFileModal()}
                </div>
            }/>


        )
    }

    //渲染筛选条件
    renderScreen() {

        return (
            <div style={{}}>
                <div style={{float: 'left'}}>
                    <div style={{float: 'left'}}>
                        <div className={'mediaListTitle'} style={{float: 'left'}}>媒体类型</div>
                        <div style={{float: 'left', width: 140}}><Select className={'mediaListContent'}
                                                                         value={this.state.mediaTypes}
                                                                         style={{width: '100%'}}
                                                                         onChange={(e) => {
                                                                             this.state.mediaTypes = e;
                                                                             this.TypeChange();
                                                                         }}>
                            <Option value={null}>请选择</Option>
                            <Option value={2}>公众号({this.state.weiChatCount})</Option>
                            <Option value={3}>微博({this.state.weiBoCount})</Option>
                            <Option value={5}>抖音({this.state.douYinCount})</Option>
                        </Select></div>
                    </div>
                    <div style={{float: 'left'}}>
                        <div className={'mediaListTitle'} style={{float: 'left'}}>是否备案</div>
                        <div style={{float: 'left', width: 140}}><Select className={'mediaListContent'}
                                                                         value={this.state.mediaRecords}
                                                                         style={{width: '100%'}}
                                                                         onChange={(e) => {
                                                                             this.state.mediaRecords = e;
                                                                             this.TypeChange();
                                                                         }}>
                            <Option value={null}>请选择</Option>
                            <Option value={1}>已备案</Option>
                            <Option value={0}>未备案</Option>
                        </Select></div>
                    </div>
                    <div style={{float: 'left'}}>
                        <div className={'mediaListTitle'} style={{float: 'left'}}>所属部门</div>
                        <div style={{float: 'left', width: 140}}><Select className={'mediaListContent'}
                                                                         value={this.state.id}
                                                                         style={{width: '100%'}}
                                                                         onChange={(e) => {
                                                                             this.state.id = e;
                                                                             this.TypeChange();
                                                                         }}>
                            <Option value={null}>请选择</Option>
                            {this.state.departAllList.map((item, i) => {
                                return (
                                    <Option key={i} value={item.id}>{item.name}</Option>
                                )

                            })

                            }
                        </Select></div>
                    </div>
                    <div style={{float: 'left'}}>
                        <div className={'mediaListTitle'} style={{float: 'left'}}>活跃度</div>
                        <div style={{float: 'left', width: 140}}><Select className={'mediaListContent'}
                                                                         value={this.state.active}
                                                                         style={{width: '100%'}}
                                                                         onChange={(e) => {
                                                                             this.state.active = e;
                                                                             this.TypeChange();
                                                                         }}>
                            <Option value={1}>请选择</Option>
                            <Option value={2}>一周未活跃</Option>
                            <Option value={3}>一个月未活跃</Option>
                            <Option value={4}>三个月未活跃</Option>
                        </Select></div>
                    </div>
                </div>
                <div style={{float: 'left', paddingLeft: 20,}}>
                    <Search className={'mediaListContent'}
                            placeholder="搜索"
                            enterButton="查询"
                            size="default"
                            value={this.state.searchText}
                            onChange={(e) => {
                                this.setState({
                                    searchText: e.target.value
                                });
                            }}
                            onSearch={value => {
                                this.search();
                            }}
                    />
                </div>
                <div style={{float: 'left', paddingLeft: 20, paddingTop: 4}}>
                    <Button onClick={() => {
                        this.revert()
                    }} type="primary">重置</Button>
                </div>
                <div style={{clear: 'both'}}/>
            </div>
        )
    }

    //渲染西面内容部分
    renderList() {

        /* let list = [{
             title: '清华大学',
             iconUrl: 'https://static-data.eol.cn/upload/logo/140.jpg',
             mark: '清华学院',
             dateMark: '已超过一个月未发文',
             accountNumber: 143143213215,
             colorType: 1,
             recordStatues: true

         }
         ];*/
        let list = this.state.listDataSource;
        return (
            <div style={{padding: 20}}>
                {list.length < 1 ? <Empty/> : null}
                {list.map((item, i) => {
                    let dateMark = item.lastUpdate ? utils.timeago(item.lastUpdate) : '';
                    let colorType = 0;
                    if(dateMark){
                        if (dateMark.includes('周')) {
                            colorType = 3;
                        }
                        if (dateMark.includes('月') || dateMark.includes('月')) {
                            colorType = 2;
                        }
                        if (dateMark.includes('1月') || dateMark.includes('2月')) {
                            colorType = 1;
                        }
                    }


                    let user=item.user?JSON.parse(item.user):null;
                    let coverUrl;
                    //默认图标设置
                    let mediaImg=weChat;
                    if(item.type===2){
                        mediaImg=weChat;
                    }else if(item.type===3){
                        mediaImg=microBlog;
                        coverUrl=user&&user.avatar_large?user.avatar_large:null
                    }else if(item.type===5){
                        mediaImg=tiktok;
                        coverUrl=user&&user.avatar?user.avatar:null
                    }


                    return (
                        <div key={i} style={{float: 'left', paddingRight: 20, paddingBottom: 20}}>
                            <MediaInformation
                                title={item.name}
                                iconUrl={coverUrl?coverUrl:""}
                                mark={item.deptName ? item.deptName : ''}
                                dateMark={dateMark}
                                accountNumber={item.account}
                                customIconWidthHeight={60}
                                colorType={colorType}
                                keepRecordIconShow={item.record}
                                defaultImg={mediaImg}
                                onClickFunction={() => {
                                    this.clickItem(item)
                                }}
                                onClickBottomFunction={() => {
                                    this.onClickBottomFunction(item)
                                }}

                            />
                        </div>
                    )
                })}
                <div style={{clear: 'both'}}/>
                {list.length > 0 ? <div style={{padding: 10}}>
                    <Pagination
                        showQuickJumper
                        // defaultCurrent={2}
                        current={this.state.page}
                        pageSize={this.state.size}
                        total={this.state.listTotal}
                        showTotal={total => `共 ${total} 条`}
                        showSizeChanger
                        onChange={(page, pageSize) => this.onChange(page, pageSize)}
                        onShowSizeChange={(page, pageSize) => {
                            this.showSizeChange(page, pageSize)
                        }}
                    />
                </div> : null}

            </div>
        )
    }

    //渲染备案信息
    renderModal() {
        let that = this;
        const props = {
            name: 'file',
            action: '/cm-sites-pms/ueditor/control?action=uploadimage',
            accept: '.png,.jpg,.gif,.jpeg,.bmp,.webp,.webp2',
            showUploadList: false,
            onChange(info) {
                if (info.file.status !== 'uploading') {
                    console.log(info.file, info.fileList);
                }
                if (info.file.status === 'done') {
                    that.state.recordMeida.url = info.file.response.url ? info.file.response.url : null;
                    console.log(info.file, info.fileList);

                } else if (info.file.status === 'error') {
                    console.log(info.file, info.fileList);
                }
            },
        };
        let mediaImg=weChat;
        if(this.state.recordMeida.type==='2'){
            mediaImg=weChat;
        }else if(this.state.recordMeida.type==='3'){
            mediaImg=microBlog;
        }else if(this.state.recordMeida.type==='5'){
            mediaImg=tiktok;
        }

        return (
            <Modal
                title={'媒体信息'}
                visible={this.state.visible}
                onOk={() => {
                }}
                onCancel={() => {
                    this.state.visible = false;
                    this.revertModal();
                }}
                /* bodyStyle={{height: 500}}*/
                width={814}
                footer={
                    <div>
                        {
                            this.state.recordMeida.status?null:<Popconfirm
                                title="此账号将要删除你还要继续吗？"
                                onConfirm={() => {
                                    this.delMediaById()
                                }}
                                onCancel={() => {
                                }}
                                okText="继续"
                                cancelText="取消"
                            >
                                <Button type="primary">删除账号</Button>
                            </Popconfirm>
                        }
                        <Popconfirm
                            title="此媒体将关闭备案你还要继续吗？"
                            onConfirm={() => {
                                this.closeRecord()
                            }}
                            onCancel={() => {
                            }}
                            okText="继续"
                            cancelText="取消"
                        >
                            <Button type="primary">关闭备案</Button>
                        </Popconfirm>
                        <Popconfirm
                            title="此媒体将通过备案你还要继续吗？"
                            onConfirm={() => {
                                this.state.recordMeida.status ? this.revertRecord()
                                    : this.okRecord()

                            }}
                            onCancel={() => {
                            }}
                            okText="继续"
                            cancelText="取消"
                        ><Button type="primary">{this.state.recordMeida.status ? '重新备案' : '确定备案'}</Button>
                        </Popconfirm>
                        <Popconfirm
                            title="此媒体将修改你还要继续吗？"
                            onConfirm={() => {
                                this.updateRecord()
                            }}
                            onCancel={() => {
                            }}
                            okText="继续"
                            cancelText="取消"
                        >
                            <Button>确定修改</Button>
                        </Popconfirm>
                    </div>
                }
            >
                <div>
                    <div style={{textAlign: 'center'}}><img style={{height: 148, width: 148,objectFit:'cover'}}
                                                            src={this.state.recordMeida.coverUrl?this.state.recordMeida.coverUrl:mediaImg}
                                                            alt=""/></div>
                    <div style={{paddingRight:51}}>
                    <Row>
                        <div style={{padding: 10}}>
                            <Col span={4}>
                                <div className={'mediaListTitle'} style={{textAlign:'right',color:'#999999'}}>名称:</div>
                            </Col>
                            <Col span={8}>
                                <div className={'mediaListModalInfor'} style={{color:'#333333'}}>{this.state.recordMeida.name}</div>
                            </Col>
                            <Col span={4}>
                                <div className={'mediaListTitle'} style={{textAlign:'right',color:'#999999'}}>账号:</div>
                            </Col>
                            <Col span={8}>
                                <div className={'mediaListModalInfor'} style={{color:'#333333',overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'}} title={this.state.recordMeida.account}>{this.state.recordMeida.account}</div>
                            </Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{padding: 10}}>
                            <Col span={4}>
                                <div className={'mediaListTitle'}  style={{textAlign:'right',color:'#999999'}}>媒体类型:</div>
                            </Col>
                            <Col span={8}>
                                <div className={'mediaListModalInfor'} style={{color:'#333333'}}>{this.state.recordMeida.mediaTypeName}<span><img
                                    style={{width: 15, objectFit: 'cover',marginLeft:5,}} src={mediaImg} alt=""/></span></div>
                            </Col>
                            <Col span={4}>
                                <div className={'mediaListTitle'} style={{textAlign:'right',color:'#999999'}}>所属部门:</div>
                            </Col>
                            <Col span={8}>
                                <div className={'mediaListModalInfor'} style={{color:'#333333'}} >{this.state.recordMeida.deptName}</div>
                            </Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{padding: 10}}>
                            <Col span={4}>
                                <div className={'mediaListTitle'} style={{textAlign:'right',color:'#999999'}}>备案情况:</div>
                            </Col>
                            <Col span={13}>
                                {
                                    this.state.recordMeida.status ?
                                        <div
                                            className={'mediaListModalInfor'} style={{color:'#333333'}}>已备案&nbsp;{this.state.recordMeida.updateTime ? utils.formatDate(this.state.recordMeida.updateTime) : null}<span><img
                                            style={{width: 20, height: 20,marginLeft:3}} src={keepRecordIcon}
                                            alt=""/></span>
                                            {this.state.recordMeida.url ? <span onClick={() => {
                                                this.clickFile()
                                            }}>
                                            <img style={{width: 20, height: 20,marginLeft:3, cursor: "pointer"}}
                                                 src={file} alt=""/></span> : null}


                                        </div>
                                        : <div className={'mediaListModalInfor'}>未备案<span> <img
                                            style={{width: 15, height: 15, cursor: "pointer"}}
                                            src={exclamatioMark} alt=""/></span>
                                            {this.state.recordMeida.url ? <span onClick={() => {
                                                this.clickFile()
                                            }}>
                                            <img style={{width: 20, height: 20, cursor: "pointer"}}
                                                 src={file} alt=""/></span> : null}
                                        </div>
                                }
                            </Col>
                            <Col span={7}>
                                <div
                                    className={'mediaListModalInfor blue'} style={{textAlign:'right'}}>
                                    <Upload {...props}>
                                        <Button style={{color:'#0050B3',border:'none'}}>
                                           {/* <Icon type="upload"/>*/} {this.state.recordMeida.url ? '重新上传备案表' : '上传备案表'}
                                        </Button>
                                    </Upload>
                                </div>
                            </Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{padding: 10}}>
                            <Col span={4}>
                                <div className={'mediaListTitle'} style={{textAlign:'right',color:'#999999'}}>负责人:</div>
                            </Col>
                            <Col span={6}>
                                <Input style={{color:'#333333'}} className={''} value={this.state.recordMeida.director}
                                       onChange={(e) => {
                                           this.state.recordMeida.director = e.target.value
                                           this.setState({})
                                       }} disabled={!this.state.directorStatus} placeholder="请输入联系方式"/>
                                {/*  <div className={'mediaListModalInfor'}>李明</div>*/}
                            </Col>
                            <Col span={2}>
                                <div className={' blue'} style={{textAlign:'right',height:32,lineHeight:'32px'}} onClick={() => {
                                    this.setState({directorStatus: true})
                                }}>修改
                                </div>
                            </Col>
                            <Col span={4}>
                                <div className={'mediaListTitle'} style={{textAlign:'right',color:'#999999'}}>联系电话:</div>
                            </Col>
                            <Col span={6}>
                                <Input className={''} style={{color:'#333333'}} value={this.state.recordMeida.mobile}
                                       onChange={(e) => {
                                           this.state.recordMeida.mobile = e.target.value
                                           this.setState({})
                                       }} disabled={!this.state.mobileStatus} placeholder="请输入联系方式"/>
                            </Col>
                            <Col span={2}>
                                <div className={' blue'} style={{textAlign:'right',height:32,lineHeight:'32px'}} onClick={() => {
                                    this.setState({mobileStatus: true})
                                }}>修改
                                </div>
                            </Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{padding: 10}}>
                            <Col span={4}>
                                <div className={'mediaListTitle'} style={{textAlign:'right',color:'#999999'}}>上次发文:</div>
                            </Col>
                            <Col span={8}>
                                <div
                                    className={'mediaListModalInfor'} style={{color:'#333333'}}>{utils.formatMediaDate(this.state.recordMeida.lastUpdate).replaceAll('/','-') }</div>
                            </Col>
                            <Col span={12}/>
                        </div>
                    </Row>
                    <Row>
                        <div style={{padding: 10}}>
                            <Col span={4}>
                                <div className={'mediaListTitle'} style={{textAlign:'right',color:'#999999'}}>介绍:</div>
                            </Col>
                            <Col span={18}>
                                <TextArea rows={4} style={{color:'#333333'}} className={'mediaListModalInfor'} value={this.state.recordMeida.description}
                                          onChange={(e) => {
                                              this.state.recordMeida.description = e.target.value
                                              this.setState({})
                                          }} disabled={!this.state.descriptionStatus} placeholder="请输入联系方式" />
                            </Col>
                            <Col span={2}>
                                <div className={' blue'} style={{height:94,lineHeight:'150px'}} onClick={() => {
                                    this.setState({descriptionStatus: true})
                                }}>修改
                                </div>
                            </Col>
                        </div>
                    </Row>
                    </div>
                </div>

            </Modal>
        )
    }

    //渲染历史发文
    renderHistoryList() {
        return (
            <Modal
                title={this.state.historyTitle}
                visible={this.state.visibleHistory}
                onOk={() => {
                    this.setState({})
                }}
                onCancel={() => {
                    this.state.visibleHistory = false;
                    this.setState({})
                }}
                /* bodyStyle={{height: 500}}*/
                width={1200}
                footer={null}
                destroyOnClose
            >
                <ContenManagement key={utils.uuid()} historyRecord={this.state.historyRecord}/>

            </Modal>
        )
    }

    //渲染文件预览
    renderFileModal() {
        return (
            <Modal
                title={'文件预览'}
                visible={this.state.fileModalVisible}
                onOk={() => {
                }}
                onCancel={() => {
                    this.state.fileModalVisible = false;
                    this.setState({})
                }}
                width={600}
                footer={
                    null
                }
            >
                <div>
                    <img key={utils.uuid()} style={{width: 552, objectFit: 'cover'}} src={"/cm-sites-" + applicationName()+this.state.lookImgUrl} alt=""/>
                </div>

            </Modal>
        )
    }


    //下拉改变
    TypeChange() {
        this.state.page = 1;
        this.state.size = 10;//每页条数
        this.getMediaList()
    }

    //查询方法
    search() {
        this.state.page = 1;
        this.state.size = 10;//每页条数
        this.getMediaList()
    }

    //点击重置按钮
    revert() {

        this.state.mediaTypes = null;//媒体类型
        this.state.mediaRecords = null;//备案状态
        this.state.id = null;//部门
        this.state.active = 1;//活跃度
        this.state.searchText = '';//搜索文字
        this.state.page = 1;
        this.state.size = 10;//每页条数
        this.getMediaList();
    }

    //分页器内容改变的
    onChange(page, pageSize) {
        this.state.page = page;
        this.getMediaList();
    }

    showSizeChange(page, pageSize) {
        this.state.size = pageSize;
        this.getMediaList();
    }

    //点击列表每一项
    clickItem(item) {
        console.log(item)
        this.state.mediaCurrentClickItem=item
        if (item.recordId) {
            this.state.visible = true;
           let user=JSON.parse(item.user);
           let coverUrl;
            this.Actions.getMediarecord(item.recordId, (data) => {
                let Data = data;
                if (Data && Data.type) {
                    if (Data.type === '2') {
                        Data.mediaTypeName = '微信';
                    } else if (Data.type === '3') {
                        Data.mediaTypeName = '微博';
                       coverUrl=user&&user.avatar_large?user.avatar_large:null
                    } else if (Data.type === '5') {
                        Data.mediaTypeName = '抖音';
                        coverUrl=user&&user.avatar?user.avatar:null
                    }
                    Data.lastUpdate = item.lastUpdate;
                    Data.account=item.account?item.account:null;//把账号带到详情里面
                    Data.coverUrl=coverUrl?coverUrl:null;//把封面图带到详情里面
                    this.state.recordMeida = Data;
                    this.state.lookImgUrl=Data.url;
                    this.setState({})
                }

            })
        }

    }
    //删除账号
    delMediaById(){
        let  params={
            mediaId:this.state.mediaCurrentClickItem.id,
        };
       this.setState({visible:false});
        Action.delMediaById(params,res=>{
            this.getMediaList()
        })
    }

    //关闭备案
    closeRecord() {
        this.state.recordMeida.status = 0;
        this.updateRecord();
    }

    //重新备案
    revertRecord() {
        this.state.updateTimeStatus = true;
        this.updateRecord();
    }

    //确定备案
    okRecord() {
        this.state.recordMeida.status = 1;
        this.state.updateTimeStatus = true;
        this.updateRecord();
    }

    //更新备案以及备案状态
    updateRecord() {
        let updateTime = null;
        if (this.state.updateTimeStatus) {
            updateTime = moment().format('YYYY-MM-DD HH:mm:ss');
        }
        let regular = /^1(3|4|5|6|7|8|9)\d{9}$/;
        if (!regular.test(this.state.recordMeida.mobile)) {
            message.warn('请输入正确的联系电话');
            return
        }
        this.Actions.addMediaRecord(JSON.stringify({...this.state.recordMeida}), updateTime, (data) => {
            this.state.visible = false;
            this.revertModal();
            this.getMediaList();
        })
    }

    //点击媒体信息的文件
    clickFile() {
        this.setState({fileModalVisible: true})
    }

    //重置媒体信息弹出框
    revertModal() {
        this.setState({
            directorStatus: false,
            mobileStatus: false,
            descriptionStatus: false,
            updateTimeStatus: false,
        })
        // console.log('重置弹出框内容')
    }



    //点击媒体信息底部历史发文
    onClickBottomFunction(item) {
        this.setState({
            visibleHistory: true,
            historyTitle: item.name,
            historyRecord: item,
            visible: false
        })
    }
}

class ContenManagement extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.Actions = Action;
        this.state = {
            statusName: '发布',//发布状态
            startDate: null,//开始时间
            endDate: null,//结束时间
            searchText: '',//搜索的文字
            mediaType: this.props.historyRecord.type,
            page: 1,//当前页数
            size: 10,//当前页数据条数,
            dataSource: [],//列表数据源
            totalElements: 0,//总条数
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getList()
    }

    getList() {
        let type = this.props.historyRecord.type;
        if (type === 2) {
            this.getwechatList();
        }
        if (type === 3) {
            this.getWeiBoList();
        }
        if (type === 5) {
            this.getDouyinList();
        }
    }


    //获取微信列表
    getwechatList() {
        let mediaCode = this.props.historyRecord.code;
        let startDate = this.state.startDate ? this.state.startDate.format(' YYYY-MM-DD') + ' 00:00:00' : null;//YYYY-MM-DD HH:mm:ss
        let endDate = this.state.endDate ? this.state.endDate.format(dateFormat) + ' 23:59:59' : null;
        let body = {
            page: this.state.page - 1,//当前页后台起始页从0开始
            size: this.state.size,//当前页面
            statusName: encodeURI ( this.state.statusName),//发布状态
            startDate: startDate,//开始时间
            endDate: endDate,//结束时间
            //Integer: '',//部门id
            search: utils.filtUrl(encodeURI(this.state.searchText)),//搜索状态
            mediaCode: mediaCode,//媒体编码

        };
        this.Actions.getwechatList(body, (data) => {
            let Data = data.data;
            if (Data && Data.content && Data.content.length > 0) {
                let list = Data.content;
                let NewList = [];
                list.forEach((item, i) => {
                    item.sort = i + 1;//序号
                    let firstStuffList = item.stuffList[0];//取出第一项
                    item.stuffList = item.stuffList.slice(1);//去掉第一项
                    NewList.push({
                        ...item,
                        ...firstStuffList// 赋值第一项
                    })
                });
                this.setState({
                    dataSource: NewList,
                    totalElements: Data.totalElements,
                },()=>{
                    $('.ant-pagination-options-quick-jumper').find('input').val('')
                })

            } else {
                this.setState({
                    dataSource: [],
                    totalElements: 0,
                })
            }
        })
    }

    //获取微博列表
    getWeiBoList() {
        let startDate = this.state.startDate ? this.state.startDate.format(' YYYY-MM-DD') + ' 00:00:00' : null;//YYYY-MM-DD HH:mm:ss
        let endDate = this.state.endDate ? this.state.endDate.format(dateFormat) + ' 23:59:59' : null;
        let mediaCode = this.props.historyRecord.code;
        let body = {
            page: this.state.page - 1,//当前页后台起始页从0开始
            size: this.state.size,//当前页面
            statusName: encodeURI( this.state.statusName),//发布状态
            startDate: startDate,//开始时间
            endDate: endDate,//结束时间
            //Integer: '',//部门id
            search: utils.filtUrl(encodeURI(this.state.searchText)),//搜索状态
            mediaCode: mediaCode,//媒体编码

        };
        this.Actions.getWeiBoList(body, (data) => {
            let Data = data.data;
            if (Data && Data.content && Data.content.length > 0) {
                let list = Data.content;
                list.forEach((item, i) => {
                    item.sort = i + 1;//序号
                    item.title = item.content;//标题
                    item.submitUser = item.user;//发布人
                    item.account = item.mediaName;//账号名称
                    item.deptName = item.deptName;//所属部门
                })
                this.setState({
                    dataSource: list,
                    totalElements: Data.totalElements,
                },()=>{
                    $('.ant-pagination-options-quick-jumper').find('input').val('')
                })

            } else {
                this.setState({
                    dataSource: [],
                    totalElements: 0,
                })
            }
        })
    }

    //获取抖音列表
    getDouyinList() {
        let startDate = this.state.startDate ? this.state.startDate.format(' YYYY-MM-DD') + ' 00:00:00' : null;//YYYY-MM-DD HH:mm:ss
        let endDate = this.state.endDate ? this.state.endDate.format(dateFormat) + ' 23:59:59' : null;
        let mediaCode = this.props.historyRecord.code;
        let body = {
            page: this.state.page - 1,//当前页后台起始页从0开始
            size: this.state.size,//当前页面
            statusName:encodeURI( this.state.statusName),//发布状态
            startDate: startDate,//开始时间
            endDate: endDate,//结束时间
            // Integer: '',//部门id
            search: utils.filtUrl(encodeURI(this.state.searchText)),//搜索状态
            mediaCode: mediaCode,//媒体编码

        };
        this.Actions.getDouyinList(body, (data) => {
            let Data = data.data;
            if (Data && Data.content && Data.content.length > 0) {
                let list = Data.content;
                list.forEach((item, i) => {
                    item.sort = i + 1;//序号
                    // item.title = item.content;//标题
                    item.submitUser = item.user;//发布人
                    item.account = item.mediaName;//账号名称
                    item.deptName = item.deptName;//所属部门
                })
                this.setState({
                    dataSource: list,
                    totalElements: Data.totalElements,
                })

            } else {
                this.setState({
                    dataSource: [],
                    totalElements: 0,
                })
            }
        })
    }


    render() {
        let height = window.innerHeight - 70;
        return (
            <div className={'ContenManagement'}
                 style={{position: 'relative', padding: 20}}>
                {/*  <Scrollbars>*/}
                <div style={{background: 'white'}}>
                    {this.renderScreen()}
                    {this.props.historyRecord.type === 2 ? this.renderWechat() : null}
                    {this.props.historyRecord.type === 3 || this.props.historyRecord.type === 5 ? this.renderWeiboOrDouyin() : null}
                    {/*// 微信预览*/}
                    <WeChatReview ref={(WeChatReview) => {
                        this.WeChatReview = WeChatReview
                    }}/>
                    {/*微博预览*/}
                    <MicroBlogReview ref={(MicroBlogReview) => {
                        this.MicroBlogReview = MicroBlogReview
                    }}/>
                    {/*抖音预览*/}
                    <TiktokReview ref={(TiktokReview) => {
                        this.TiktokReview = TiktokReview
                    }}/>
                </div>
                {/* </Scrollbars>*/}
            </div>
        )
    }

    //渲染筛选条件
    renderScreen() {

        return (
            <div style={{borderBottom: '1px solid #ebebeb'}}>
                <div style={{float: 'left'}}>
                    <div style={{float: 'left'}}>
                        {/* <Tabs defaultActiveKey={this.state.statusName} activeKey={this.state.statusName}
                              onChange={(key) => {
                                  this.state.statusName = key;
                                  this.TypeChange();
                              }} tabBarGutter={0}>
                            <TabPane tab={"全部"} key={''}>
                            </TabPane>
                            <TabPane tab={"已发布"} key={'发布'}>
                            </TabPane>
                            <TabPane tab={"待发布"} key={'待发布'}>
                            </TabPane>


                        </Tabs> */}
                    </div>
                    <div style={{float: 'left'}}>
                        <div className={'ContenManagementTitle'} style={{float: 'left'}}>自定义时间</div>
                        <div style={{float: 'left', width: 210, marginTop: 6}}>
                            <RangePicker
                                value={[this.state.startDate, this.state.endDate]}
                                format={dateFormat}
                                onChange={(date, dateString) => {
                                    this.state.startDate = date[0];
                                    this.state.endDate = date[1];
                                    this.TypeChange();
                                }}
                            />
                        </div>
                    </div>

                </div>
                <div style={{float: 'left', paddingLeft: 20,}}>
                    <div style={{height: 32, marginTop: 6}}><Search className={'ContenManagementContent'}
                                                                    placeholder="搜索"
                                                                    enterButton="查询"
                                                                    size="default"
                                                                    value={this.state.searchText}
                                                                    onChange={(e) => {
                                                                        this.setState({
                                                                            searchText: e.target.value
                                                                        });
                                                                    }}
                                                                    onSearch={value => {
                                                                        this.search();
                                                                    }}
                    /></div>

                </div>
                <div style={{float: 'left', paddingLeft: 20, paddingTop: 4}}>
                    <Button onClick={() => {
                        this.revert()
                    }} type="primary">重置</Button>
                </div>
                <div style={{clear: 'both'}}/>
            </div>
        )
    }

    //渲染微信内容
    renderWechat() {


        let titleKeyList =
            [{
                key: 'title',
                titleName: '标题',
                align: 'center',
                ellipsis: true,
                render: (text, record, index) => {
                    return (<div onClick={() => {
                            this.itemClick(record)
                        }}>
                            <div style={{position: 'relative',}}>
                                <div style={{
                                     width: 200,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    fontWeight: 'bold', textAlign: 'left', cursor: 'pointer'
                                }}
                                     title={record.title}>{record.title}</div>
                            </div>

                        </div>

                    )
                }
            },
                {
                    key: 'createTime',
                    titleName: '发布时间',
                    align: 'center',
                    ellipsis: true,
                    width: 200,
                    render: (text, record, index) => {
                        return (<div>
                                {utils.formatMediaDate(record.publishTime).replaceAll('/','-')}
                            </div>

                        )
                    }
                },
                {
                    key: 'wxNickname',
                    titleName: '账号名称',
                    align: 'center',
                    ellipsis: true,
                    width: 150,
                },
                {
                    key: 'newsReadCount',
                    titleName: '阅读（转评赞）',
                    width: 150,
                    align: 'center',
                }, {
                key: 'deptName',
                titleName: '所属部门',
                align: 'center',
                ellipsis: true,
                width: 150,
                render: (text, record, index) => {
                    return (<div>
                            {record.deptName?record.deptName:'暂无部门'}
                        </div>

                    )
                }
            },/* {
                key: 'user',
                titleName: '发布人',
                align: 'center',
                ellipsis: true,
                width: 150,
                render: (text, record, index) => {
                    return (<div>
                            {record.user ? record.user : '未知'}
                        </div>

                    )
                }
            }*/];
        return (
            <div className={'mediaHistory'} style={{paddingTop: 10}}>

                <CustomTable
                    dataSource={this.state.dataSource}
                    titleKeyList={titleKeyList}
                    //下面属性参考antd table  属性去使用对外暴露，会全部引用用antd 的属性。
                    childrenColumnName={['stuffList']}
                    pagination={{
                        showQuickJumper: true,
                        total: this.state.totalElements,
                        current:this.state.page,
                        onChange: (e) => {
                            this.paginationChange(e)
                        },
                        style: {marginRight: '20px'},
                        showTotal: total => `共 ${total} 条数据`,
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '30', '40'],
                        onShowSizeChange: (page, pageSize) => {
                            this.showSizeChange(page, pageSize)
                        },
                        position: 'bottom'//这个版本目前只支持上下，不支持bottomLeft
                    }}
                    onRow={record => {
                        return {
                            onClick: event => {
                                // console.log('点击了媒体内容的一行')
                            }, // 点击行
                        };
                    }}
                    locale={{emptyText: '暂无数据'}}

                />
            </div>
        )
    }

    //渲染微博抖音内容
    renderWeiboOrDouyin() {


        let titleKeyList =
            [{
                key: 'title',
                titleName: '标题',
                align: 'center',
                ellipsis: true,
                render: (text, record, index) => {
                    return (<div onClick={() => {
                            this.itemClick(record)
                        }}>
                            <div style={{position: 'relative',}}>
                                <div style={{
                                    /* width: 400,*/
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    fontWeight: 'bold', textAlign: 'left', cursor: 'pointer'
                                }}
                                     title={record.title}>{this.props.historyRecord.type === 5?(record.title?record.title:'未命名的视频'):record.title}</div>
                            </div>

                        </div>

                    )
                }
            },
                {
                    key: 'createTime',
                    titleName: '发布时间',
                    align: 'center',
                    ellipsis: true,
                    width: 250,
                    render: (text, record, index) => {
                        if(this.state.mediaType === 3){
                            return (<div>
                                    {record.createDate}
                                </div>
                            )
                        }else{
                            return (<div>
                                    {record.publishDate}
                                </div>
                            )
                        }
                    }
                },
                {
                    key: 'account',
                    titleName: '账号名称',
                    align: 'center',
                    ellipsis: true,
                    width: 150
                },
                {
                    key: this.state.mediaType === 3 ? 'zpzCount' : 'playCount',
                    titleName: this.state.mediaType === 3 ? '转评赞' : '播放量',
                    width: 150,
                    align: 'center',
                    render: (text, record, index) => {
                        let num;
                        if(this.state.mediaType === 3){
                            num=record.zpzCount?record.zpzCount:0
                        }else{
                            num=record.playCount?record.playCount:0
                        }
                        return (<div>
                                {num}
                            </div>

                        )
                    }
                }, {
                key: 'deptName',
                titleName: '所属部门',
                align: 'center',
                ellipsis: true,
                width: 150,
            }, /*{
                key: 'submitUser',
                titleName: '发布人',
                align: 'center',
                ellipsis: true,
                width: 150,
            }*/];
        return (
            <div style={{paddingTop: 10}}>

                <CustomTable
                    dataSource={this.state.dataSource}
                    titleKeyList={titleKeyList}
                    //下面属性参考antd table  属性去使用对外暴露，会全部引用用antd 的属性。
                    childrenColumnName={['stuffList']}
                    pagination={{
                        showQuickJumper: true,
                        total: this.state.totalElements,
                        current:this.state.page,
                        onChange: (e) => {
                            this.paginationChange(e)
                        },
                        style: {marginRight: '20px'},
                        showTotal: total => `共 ${total} 条数据`,
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '30', '40'],
                        onShowSizeChange: (page, pageSize) => {
                            this.showSizeChange(page, pageSize)
                        },
                        position: 'bottom'//这个版本目前只支持上下，不支持bottomLeft
                    }}
                    onRow={record => {
                        return {
                            onClick: event => {
                                //console.log('点击了媒体内容的一行')
                            }, // 点击行
                        };
                    }}
                    locale={{emptyText: '暂无数据'}}

                />
            </div>
        )
    }

    //下拉改变
    TypeChange() {
        this.state.page = 1;
        this.state.size = 10;//每页条数
        this.getList()
    }

    //查询方法
    search() {
        this.state.page = 1;
        this.state.size = 10;//每页条数
        this.getList();
    }

    //点击重置按钮
    revert() {
        this.state.startDate = null;// moment().add(-1, 'days');//开始时间
        this.state.endDate = null;//moment().add(-1, 'days');//结束时间
        this.state.searchText = '';//搜索的文字
        this.state.page = 1;//当前页
        this.state.size = 10;//当前页数据条数
        this.getList()
    }

    paginationChange(e) {
        this.state.page = e;
        this.getList();
    }

    showSizeChange(page, pageSize) {
        this.state.size = pageSize;
        this.getList();
    }

    itemClick(record) {
        console.log(record)
        let type = this.props.historyRecord.type;
        if (type === 2) {
            //微信预览
            //this.WeChatReview.show(record.materialId, record.id)
            utils.openNewWindow(record.url)
        }
        if (type === 3) {
            //微博预览
            utils.openNewWindow(record.publishUrl)
            /*let reviewParms = {
                /!*  title: record.title,*!/
                /!*  titlePic: record.picUrl,*!/
                updateDate: utils.formatDate(record.updateDate),//内容
                content: record.content,
                picUrls: record.picUrls,
                /!*   author: record.user,*!/
                publishUrl: record.publishUrl
            }
            this.MicroBlogReview.show(reviewParms)*/
        }
        if (type === 5) {
            //抖音预览
            utils.openNewWindow(record.videoShareUrl)
           /* let reviewParms = {
                title: record.title,
                titlePic: record.coverUrl,
                updateDate: record.updateDate,
                author: record.user,
                videoUrl: record.videoUrl
            }
            this.TiktokReview.show(reviewParms)*/
        }

    }


}